export default __webpack_public_path__ + "static/media/img-stake-explorer-new.050a34c4.png";